import React, { useEffect, useState } from "react";
import { getIconsApi } from "../../api";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { setIcons } from "../../redux";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";

const WidgetSettingComp = (props) => {
  const { t } = useTranslation();
  const {
    zone,
    toggleCommands,
    toggleScheduleList,
    toggleEdit,
    toggleMove,
    toggleInfo,
    toggleDeviceInfo,
    toggleLearn,
  } = props;
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    getIconsApi(token)
      .then((res) => {
        dispatch(setIcons(res.data.data));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  }, []);

  return (
    <div style={{ height: "auto" }}>
      <div className="d-flex align-items-center flex-column">
        <i className="circleTop icon-plug text-center"></i>
        <div className="text-center mt-2">
          <p className="m-0">
            {t("تنظیمات")}
            {""}
          </p>
          <p className="fn12 text-muted">{zone.caption}</p>
        </div>
      </div>

      <div
        className="w-100 text-right borderBottom mb-3 cursor"
        onClick={toggleMove}
      >
        <p className="fn">{t("انتقال به اتاق دیگر")}</p>
      </div>
      <div
        className="w-100 text-right borderBottom mb-3 cursor"
        onClick={toggleCommands}
      >
        <p className="fn">{t("زمانبندی")}</p>
      </div>
      <div
        className="w-100 text-right borderBottom mb-3 cursor"
        onClick={toggleScheduleList}
      >
        <p className="fn">{t("لیست زمانبندی ها")}</p>
      </div>
      <div
        className="w-100 text-right borderBottom mb-3 cursor"
        onClick={toggleInfo}
      >
        <p className="fn">{t("اطلاعات ویجت")}</p>
      </div>
      <div
        className="w-100 text-right borderBottom mb-3 cursor"
        onClick={toggleEdit}
      >
        <p className="fn">{t("ویرایش ویجت")}</p>
      </div>
      {zone.property[0] === "Widget4" || zone.property[0] === "Widget5" ? (
        <div
          className="w-100 text-right borderBottom mb-3 cursor"
          onClick={toggleLearn}
        >
          <p className="fn">{t("لرن و حذف لرن")}</p>
        </div>
      ) : (
        ""
      )}

      {/* <div className="w-100 text-right borderBottom mb-3 cursor"
                onClick={toggleDeviceInfo}>
                <p className="fn">اطلاعات دستگاه</p>
            </div> */}

      {/* <div className="w-100 text-right borderBottom mb-3 d-flex justify-content-between">
                <p className="fn">پنهان کردن</p>
                <label className="switch">
                    <input type="checkbox" id="myCheck"
                        defaultChecked={!zone.property[3]}
                        onChange={(e) => hideWidget(e)} />
                    <span className="switchSlider round"></span>
                </label>
            </div> */}
    </div>
  );
};

const WidgetSetting = withRouter(WidgetSettingComp);

export { WidgetSetting };
